export const findPredicate = (comp) => {
  switch (comp) {
    case '=':
      return 'eq';
    case '>':
      return 'gt';
    case '<':
      return 'lt';
    case '>=':
      return 'gteq';
    case '<=':
      return 'lteq';
    case '!=':
      return 'not_eq';
    default:
      return 'eq';
  }
};

export const findComparator = (predicate) => {
  switch (predicate) {
    case 'eq':
      return '=';
    case 'gt':
      return '>';
    case 'lt':
      return '<';
    case 'gteq':
      return '>=';
    case 'lteq':
      return '<=';
    case 'not_eq':
      return '!=';
    default:
      return null;
  }
};
